import { useNavigate } from 'react-router-dom';

function ErrorFallback({ error, resetErrorBoundary }) {
  const navigate = useNavigate();
  navigate('/error', { state: error });
}

export default ErrorFallback;
